(function () {
  'use strict';

  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 280;
  var RESULT_LIMIT = 8;

  var searchDrawer = document.getElementById('RabitatSearchDrawer');
  var mobileMenu = document.getElementById('RabitatMobileMenu');
  var headerGroupEl = document.querySelector('[data-rabitat-header-group]');
  var headerEl = document.querySelector('.rabitat-header');

  function updateCartCount(itemCount) {
    var count = typeof itemCount === 'number' ? itemCount : 0;
    var ariaLabel = count > 0 ? 'Cart, ' + count + ' item' + (count === 1 ? '' : 's') : 'Cart';

    document.querySelectorAll('[data-rabitat-cart-link]').forEach(function (link) {
      link.setAttribute('aria-label', ariaLabel);
      var countEl = link.querySelector('[data-rabitat-cart-count]');
      if (countEl) {
        countEl.textContent = count;
        countEl.hidden = count <= 0;
      }
    });

    var mobileCart = document.querySelector('[data-rabitat-mobile-cart]');
    if (mobileCart) {
      mobileCart.textContent = count > 0 ? 'Cart (' + count + ')' : 'Cart';
    }
  }

  document.addEventListener('rabitat:cart:updated', function (event) {
    if (event.detail && typeof event.detail.item_count === 'number') {
      updateCartCount(event.detail.item_count);
    }
  });

  function setHeaderOffset() {
    var measureEl = headerGroupEl || headerEl;
    if (measureEl) {
      document.documentElement.style.setProperty('--rabitat-header-height', measureEl.offsetHeight + 'px');
    }
  }

  if (headerGroupEl || headerEl) {
    window.requestAnimationFrame(setHeaderOffset);
    window.addEventListener('resize', setHeaderOffset, { passive: true });

    if (typeof ResizeObserver !== 'undefined' && headerGroupEl) {
      var headerObserver = new ResizeObserver(setHeaderOffset);
      headerObserver.observe(headerGroupEl);
    }
  }

  if (!searchDrawer && !mobileMenu) return;
  function lockScroll() {
    document.documentElement.classList.add('rabitat-scroll-lock');
    document.body.classList.add('rabitat-scroll-lock');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('rabitat-scroll-lock');
    document.body.classList.remove('rabitat-scroll-lock');
  }

  function closeSearch() {
    if (!searchDrawer) return;
    searchDrawer.classList.remove('is-open');
    searchDrawer.setAttribute('aria-hidden', 'true');
    unlockScroll();
    var input = searchDrawer.querySelector('[data-search-input]');
    var clear = searchDrawer.querySelector('[data-search-clear]');
    var list = searchDrawer.querySelector('[data-search-list]');
    if (input) input.value = '';
    if (clear) clear.hidden = true;
    var idle = searchDrawer.querySelector('[data-search-idle]');
    var loading = searchDrawer.querySelector('[data-search-loading]');
    var results = searchDrawer.querySelector('[data-search-results]');
    var empty = searchDrawer.querySelector('[data-search-empty]');
    if (idle) idle.hidden = false;
    if (loading) loading.hidden = true;
    if (results) results.hidden = true;
    if (empty) empty.hidden = true;
    if (list) list.innerHTML = '';
  }

  /* ── Mobile menu ── */
  if (mobileMenu) {
    var menuToggle = document.querySelector('[data-menu-open]');
    var menuCloseEls = mobileMenu.querySelectorAll('[data-menu-close]');

    function closeMobileSubmenus() {
      mobileMenu.querySelectorAll('.rabitat-mobile-menu__item.is-expanded').forEach(function (item) {
        item.classList.remove('is-expanded');
        var toggle = item.querySelector('[data-mobile-submenu-toggle]');
        var panelContent = item.querySelector('.rabitat-mobile-menu__panel-content');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (panelContent) panelContent.hidden = true;
      });
    }

    function openMenu() {
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      if (menuToggle) {
        menuToggle.setAttribute('aria-expanded', 'true');
        menuToggle.setAttribute('aria-label', 'Close menu');
      }
      lockScroll();
    }

    function closeMenu() {
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      closeMobileSubmenus();
      if (menuToggle) {
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.setAttribute('aria-label', 'Open menu');
        menuToggle.focus();
      }
      unlockScroll();
    }

    mobileMenu.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item = toggle.closest('.rabitat-mobile-menu__item');
        var panelContent = item ? item.querySelector('.rabitat-mobile-menu__panel-content') : null;
        if (!item || !panelContent) return;

        var willExpand = !item.classList.contains('is-expanded');

        closeMobileSubmenus();

        if (willExpand) {
          item.classList.add('is-expanded');
          panelContent.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    if (menuToggle) {
      menuToggle.addEventListener('click', function () {
        if (mobileMenu.classList.contains('is-open')) {
          closeMenu();
        } else {
          closeSearch();
          openMenu();
        }
      });
    }

    menuCloseEls.forEach(function (el) {
      el.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) closeMenu();
    });
  }

  /* ── Search drawer ── */
  if (!searchDrawer) return;

  var searchOpenBtns = document.querySelectorAll('[data-search-open]');
  var searchCloseEls = searchDrawer.querySelectorAll('[data-search-close]');
  var searchInput = searchDrawer.querySelector('[data-search-input]');
  var searchClear = searchDrawer.querySelector('[data-search-clear]');
  var searchForm = searchDrawer.querySelector('[data-search-form]');
  var idleState = searchDrawer.querySelector('[data-search-idle]');
  var loadingState = searchDrawer.querySelector('[data-search-loading]');
  var resultsState = searchDrawer.querySelector('[data-search-results]');
  var emptyState = searchDrawer.querySelector('[data-search-empty]');
  var resultsList = searchDrawer.querySelector('[data-search-list]');
  var resultsCount = searchDrawer.querySelector('[data-search-count]');
  var viewAllLink = searchDrawer.querySelector('[data-search-view-all]');
  var moneyFormat = searchDrawer.getAttribute('data-money-format') || '${{amount}}';

  var debounceTimer = null;
  var abortController = null;
  var cache = {};

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function showState(state) {
    if (!idleState) return;
    idleState.hidden = state !== 'idle';
    loadingState.hidden = state !== 'loading';
    resultsState.hidden = state !== 'results';
    emptyState.hidden = state !== 'empty';
  }

  function openSearch() {
    closeMenuIfOpen();
    searchDrawer.classList.add('is-open');
    searchDrawer.setAttribute('aria-hidden', 'false');
    lockScroll();
    window.setTimeout(function () {
      if (searchInput) searchInput.focus();
    }, 320);
  }

  function closeMenuIfOpen() {
    if (mobileMenu && mobileMenu.classList.contains('is-open')) {
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      mobileMenu.querySelectorAll('.rabitat-mobile-menu__item.is-expanded').forEach(function (item) {
        item.classList.remove('is-expanded');
        var toggle = item.querySelector('[data-mobile-submenu-toggle]');
        var panelContent = item.querySelector('.rabitat-mobile-menu__panel-content');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (panelContent) panelContent.hidden = true;
      });
      var toggle = document.querySelector('[data-menu-open]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
      }
    }
  }

  searchOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openSearch();
    });
  });

  searchCloseEls.forEach(function (el) {
    el.addEventListener('click', closeSearch);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchDrawer.classList.contains('is-open')) closeSearch();
  });

  if (searchClear) {
    searchClear.addEventListener('click', function () {
      if (searchInput) {
        searchInput.value = '';
        searchInput.focus();
      }
      searchClear.hidden = true;
      showState('idle');
      if (resultsList) resultsList.innerHTML = '';
    });
  }

  function normalizeCollectionProduct(product) {
    var variant = product.variants && product.variants.length ? product.variants[0] : null;
    var image = product.images && product.images.length ? product.images[0].src : '';
    var priceCents = variant ? Math.round(parseFloat(variant.price) * 100) : 0;
    var compareCents =
      variant && variant.compare_at_price
        ? Math.round(parseFloat(variant.compare_at_price) * 100)
        : 0;

    return {
      id: product.id,
      title: product.title,
      url: '/products/' + product.handle,
      vendor: product.vendor || '',
      available: variant ? variant.available : false,
      price: priceCents,
      compare_at_price_max: compareCents,
      featured_image: image ? { url: image } : null,
      image: image,
    };
  }

  function mergeProducts(lists, limit) {
    var merged = [];
    var seen = {};

    lists.forEach(function (list) {
      (list || []).forEach(function (product) {
        if (!product || !product.id || seen[product.id]) return;
        seen[product.id] = true;
        merged.push(product);
      });
    });

    return merged.slice(0, limit);
  }

  function renderResults(payload, query) {
    var products = payload.products || [];

    if (!products.length) {
      showState('empty');
      return;
    }

    var chevronTemplate = document.getElementById('RabitatIconChevronRight');
    var chevronIcon = chevronTemplate ? chevronTemplate.innerHTML : '';

    resultsList.innerHTML = products
      .map(function (product) {
        var image = product.featured_image && product.featured_image.url
          ? product.featured_image.url
          : product.image || '';
        var imageSrc = image;
        if (image) {
          imageSrc = image.indexOf('?') > -1 ? image + '&width=160' : image + '?width=160';
        }
        var title = escapeHtml(product.title);
        var vendor = product.vendor ? escapeHtml(product.vendor) : '';
        var productAlt = escapeHtml(product.title || 'Product');
        var price = product.price ? formatMoney(product.price) : '';
        var compareAt = product.compare_at_price_max && product.compare_at_price_max > product.price
          ? formatMoney(product.compare_at_price_max)
          : '';
        var badge = !product.available ? '<span class="rabitat-search-drawer__badge">Sold out</span>' : '';
        var productUrl = escapeHtml(product.url);

        return (
          '<li class="rabitat-search-drawer__item">' +
            '<a href="' + productUrl + '" class="rabitat-search-drawer__product">' +
              '<span class="rabitat-search-drawer__product-media">' +
                (image
                  ? '<img src="' + imageSrc + '" alt="' + productAlt + '" width="80" height="80" loading="lazy">'
                  : '<span class="rabitat-search-drawer__product-placeholder"></span>') +
                badge +
              '</span>' +
              '<span class="rabitat-search-drawer__product-info">' +
                (vendor ? '<span class="rabitat-search-drawer__product-vendor">' + vendor + '</span>' : '') +
                '<span class="rabitat-search-drawer__product-title">' + title + '</span>' +
                '<span class="rabitat-search-drawer__product-price">' +
                  (compareAt ? '<s class="rabitat-search-drawer__product-compare">' + compareAt + '</s>' : '') +
                  '<span>' + price + '</span>' +
                '</span>' +
              '</span>' +
              '<span class="rabitat-search-drawer__product-arrow" aria-hidden="true">' +
                chevronIcon +
              '</span>' +
            '</a>' +
          '</li>'
        );
      })
      .join('');

    if (resultsCount) {
      resultsCount.textContent =
        products.length + ' result' + (products.length === 1 ? '' : 's') + ' for "' + query + '"';
    }

    if (viewAllLink) {
      viewAllLink.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
      viewAllLink.hidden = false;
    }

    showState('results');
  }

  function fetchSuggest(query, signal) {
    var url =
      '/search/suggest.json?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product,collection' +
      '&resources[limit]=' +
      RESULT_LIMIT +
      '&resources[options][fields]=title,product_type,variants.title,vendor,tag' +
      '&resources[options][unavailable_products]=last';

    return fetch(url, { signal: signal }).then(function (res) {
      return res.json();
    });
  }

  function fetchFullSearch(query, signal) {
    var url =
      '/search?q=' +
      encodeURIComponent(query) +
      '&type=product&section_id=rabitat-search-json';

    return fetch(url, { signal: signal })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var jsonEl = doc.querySelector('[data-search-json]');
        if (!jsonEl || !jsonEl.textContent.trim()) return [];
        return JSON.parse(jsonEl.textContent);
      })
      .catch(function () {
        return [];
      });
  }

  function fetchCollectionProducts(handle, limit, signal) {
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + limit, {
      signal: signal,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        return (data.products || []).map(normalizeCollectionProduct);
      })
      .catch(function () {
        return [];
      });
  }

  function fetchResults(query) {
    if (cache[query]) {
      renderResults(cache[query], query);
      return;
    }

    if (abortController) abortController.abort();
    abortController = new AbortController();
    var signal = abortController.signal;

    showState('loading');

    fetchSuggest(query, signal)
      .then(function (data) {
        var suggestProducts = (data.resources && data.resources.results && data.resources.results.products) || [];
        var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];

        var collectionProductFetches = collections.slice(0, 3).map(function (collection) {
          return fetchCollectionProducts(collection.handle, RESULT_LIMIT, signal);
        });

        return Promise.all([fetchFullSearch(query, signal)].concat(collectionProductFetches)).then(function (responses) {
          var fullSearchProducts = responses[0] || [];
          var collectionProductLists = responses.slice(1);
          var collectionProducts = [];

          collectionProductLists.forEach(function (list) {
            collectionProducts = collectionProducts.concat(list);
          });

          var products = mergeProducts([collectionProducts, fullSearchProducts, suggestProducts], RESULT_LIMIT);

          return {
            products: products,
            collections: collections,
          };
        });
      })
      .then(function (payload) {
        cache[query] = payload;
        renderResults(payload, query);
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        showState('empty');
      });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();

      if (searchClear) searchClear.hidden = query.length === 0;

      window.clearTimeout(debounceTimer);

      if (query.length < MIN_CHARS) {
        if (abortController) abortController.abort();
      showState('idle');
      if (resultsList) resultsList.innerHTML = '';
      if (viewAllLink) viewAllLink.hidden = true;
        return;
      }

      debounceTimer = window.setTimeout(function () {
        fetchResults(query);
      }, DEBOUNCE_MS);
    });
  }

  if (searchForm) {
    searchForm.addEventListener('submit', function (e) {
      var query = searchInput ? searchInput.value.trim() : '';
      if (query.length < MIN_CHARS) e.preventDefault();
    });
  }
})();
